import { render } from "./ShareContract.vue?vue&type=template&id=dacdb812&scoped=true"
import script from "./ShareContract.vue?vue&type=script&lang=js"
export * from "./ShareContract.vue?vue&type=script&lang=js"

import "./ShareContract.vue?vue&type=style&index=0&id=dacdb812&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/spark_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dacdb812"]])

export default __exports__